import { Component, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import {FormControl} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { TableData } from '../md/md-table/md-table.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UserService } from '../services/user.service';
import { User } from '../models/user';
import { CompanylinkedService } from '../services/companylinked.service';
import { CompanyLinked } from '../models/companylinked';
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import swal from 'sweetalert2';

declare const require: any;

declare const $: any;

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}

export interface UserList {
  value: string;
  name: string;
}

@Component({
    selector: 'app-uploaduneda-cmp',
    templateUrl: 'uploaduneda.component.html',
    providers: [UserService, CompanylinkedService]
})

export class UploadunedaComponent implements OnInit, AfterViewInit {
  public identity;
  public token;
  public privilegio;
	
   public tableContacts: DataTable;

   public loading;
  
   //public contacts;
  
  public dataTable: DataTable;
  public pacientes: Array<User>;
   public idUser;

   public user: CompanyLinked;
   //public user;

  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public searchString;
  public status_user;
  public idCompany;
  public companyFather;
  public unedaEnabled;
  public unedaIqKey;
  public unedaType;

  public lastSync: any;

     constructor(
      public dialog: MatDialog, private _userService: UserService, 
      private _companylinkedService: CompanylinkedService,
      private _route: ActivatedRoute,
      private _router: Router) {
      this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
      console.log(this.privilegio);
      
    this.identity = this._userService.getIdentity();

if(this.identity == null){
    localStorage.clear();
      this._router.navigate(['/pages/lock']);
}

    this.token = this._userService.getToken();

    this._route.params.forEach((params: Params) => {
       this.idUser =+ params['id'];
      console.log("iduser: " + this.idUser );

    });

   this.status_user = '';

  }

     ngOnInit() {

     if(this.identity == null && this.identity.sub){
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {
      console.log("ngOnInit");
      this.getUser();
      
  }



   }

selectedFile: File;

  onFileSend(event) {
    $('.loader').show();
    $(".drop-zone").css("opacity", "0.3");
    $('#confirmuploadedfile').hide();
    var xhr = new XMLHttpRequest();
    this.selectedFile = <File>event.target.files[0];
    let headers = new Headers({'Content-Type': 'multipart/form-data'});

    const uploadData = new FormData();
    uploadData.append('namefile', this.selectedFile, this.selectedFile.name);
    uploadData.append('idpaciente', this.idCompany);
   // uploadData.append('idfather', this.id);
    uploadData.append('type', 'UNEDAINVENTORY');
    console.log(uploadData);

    let met = this;

    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          //  console.log(xhr.response);
          let respuesta = JSON.parse(xhr.response);
          console.log(respuesta.status);
          console.log(respuesta.img);

          if (respuesta.status == 'success') {
            $('.loader').hide();
            $('#confirmuploadedfile').show();
             $(".drop-zone").css("opacity", "1");
           
          } else {
             $('.loader').hide();
            $('#erroruploadedfile').show();
             $(".drop-zone").css("opacity", "1");
          }
        } else {
          console.log(xhr.response);
        }
      }
    }

    xhr.open('POST', 'https://itaderp.com/backend/resources/receiver.php', true);
    //xhr.setRequestHeader('Authorization',token);
    xhr.send(uploadData);
  }


     ngAfterViewInit() {

 var self = this; // get a reference to `this`



    }

	animal: string = 'Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium.'
+ 'Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugia';
  name: string;

  onSubmit(){/*
    console.log(this.user);
    this._companylinkedService.update(this.token, this.user, this.idUser).subscribe(
        response => {
          console.log(response);
          this.status_user = response.status;
          console.log(this.status_user);
          if(this.status_user != 'success'){
            this.status_user = 'error';
          } else {
            this.user = response.data;
           
            //this._router.navigate(['/task', this.task.id]);
         
           
          }
        },
        error => {
          console.log(<any>error);
        }
      );*/
  }


typechange(){
  this.loading = 'show';

  console.log("cambio");
  console.log(this.unedaType);

  let enviar = {
    "type": "TYPESYNC",
    "value": this.unedaType
  }

  this._companylinkedService.updatebyparam(this.token, enviar, this.idCompany).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
             
             
             
              this.loading = 'hide';
            
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );
}

iqsync(){
  this.loading = 'show';

  console.log("cambio");
  console.log(this.unedaType);

  let enviar = {
    "type": "APIKEY",
    "value": this.unedaIqKey
  }

  this._companylinkedService.updatebyparam(this.token, enviar, this.idCompany).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
             
             
             
              this.loading = 'hide';
            
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );
}


  getUser(){

    this.loading = 'show';
   
   

   this._userService.getUser(this.token, this.identity.sub).subscribe(
        response => {
          console.log('Usuario: ');
          console.log(response);

          if (response.status == 'success') {
            this.idCompany = response.data.companyLinked.id;
            this.companyFather = response.data.companyLinked;
            
            this.unedaEnabled = this.companyFather.unedaEnabled;
            this.unedaIqKey = this.companyFather.unedaIqKey;
            this.unedaType = this.companyFather.unedaType;
            this.lastSync = response.data.companyLinked.lastUnedaSync.timestamp * 1000;
console.log(this.lastSync);
             this._companylinkedService.getCompany(this.token, response.data.companyLinked.id).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
              this.user = response.data;
             
             
              this.loading = 'hide';
            
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );

             
            
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );

   
    
     
 
  }


showSwal(type) {
      if (type === 'success-citas') {
            swal.fire({
             
                title: 'Cita agendada con éxito!',
                text: 'Has agendando una nueva cita.',
                buttonsStyling: false,
              customClass:{
    confirmButton: 'btn btn-success'
            },

            });

        } else if (type === 'success-message') {
            swal.fire({
               
                title: '¡Paciente guardado con éxito!',
                text: 'Has guardado un nuevo paciente.',
                buttonsStyling: false,
             customClass:{
    confirmButton: 'btn btn-success'
            },

            });

        } else if (type === 'warning-message-and-confirmation') {
            swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to revert this!',
                  
                    showCancelButton: true,
                   
                    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
                    confirmButtonText: 'Yes, delete it!',
                    buttonsStyling: false
                }).then(function() {
                  swal.fire({
                    title: 'Deleted!',
                    text: 'Your file has been deleted.',
                  
                   customClass:{
    confirmButton: 'btn btn-success'
            },
                    buttonsStyling: false
                });
                });
            } else if (type === 'warning-message-and-cancel') {
            swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this imaginary file!',
                
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, keep it',
                  
                    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
                    buttonsStyling: false
                }).then(function() {
                  swal.fire({
                    title: 'Deleted!',
                    text: 'Your imaginary file has been deleted.',
                 
                  customClass:{
    confirmButton: 'btn btn-success'
            },
                    buttonsStyling: false
                });
                }, function(dismiss) {
                  // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                  if (dismiss === 'cancel') {
                    swal.fire({
                      title: 'Cancelled',
                      text: 'Your imaginary file is safe :)',
                   
                    
                      customClass:{
    confirmButton: 'btn btn-info'
            },
                      buttonsStyling: false
                  });
                  }
              });
          } else if (type === 'custom-html') {
            swal.fire({
                title: 'HTML example',
                buttonsStyling: false,
              
                 customClass:{
    confirmButton: 'btn btn-success'
            },
                html:
                        'You can use <b>bold text</b>, ' +
                        '<a href="http://github.com">links</a> ' +
                        'and other HTML tags'
                });

            } else if (type === 'auto-close') {
            swal.fire({  title: 'Auto close alert!',
                    text: 'I will close in 2 seconds.',
                    timer: 2000,
                    showConfirmButton: false
                }).then(
                    function () {},
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                            console.log('I was closed by the timer')
                        }
                });
            } else if (type === 'input-field') {
            swal.fire({
                    title: 'Input something',
                    html: '<div class="form-group">' +
                              '<input id="input-field" type="text" class="form-control" />' +
                          '</div>',
                    showCancelButton: true,
                 
                    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
                    buttonsStyling: false
                }).then(function(result) {
                    swal.fire({
                      
                        html: 'You entered: <strong>' +
                                $('#input-field').val() +
                              '</strong>',
                        
                        customClass:{
    confirmButton: 'btn btn-success'
            },
                        buttonsStyling: false

                    });
                });
        }


    }


	
}